// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1679":"85396a53","5264":"ed56465b","5879":"ed56465b","6937":"ed56465b"}[chunkId] + ".chunk.css";
};